import { get, set } from 'lodash'

export const first = (obj) => {
    for (let key in obj) return obj[key]
}

export const urlParams = (obj, host) => {
    let params = []
    for (let key in obj) {
        let val =  obj[key]
        if (['null', 'undefined', 'NaN'].indexOf(typeof val) > -1) val = ''
        if (typeof val === 'object') val = JSON.stringify(val) 
        params.push([key, val].join('='))
    }
    params = params.join('&')
    return typeof host === 'string'
        ? [host, params].join('?') 
        : params
}

export default {
    install(Vue, options) {
        Vue.prototype.$object = {
            get,
            set,
            first,
            urlParams
        }
    }
}


// WEBPACK FOOTER //
// ./utils/object.js